<template>
  <b-modal :active.sync="isModalActive" :width="960" scroll="clip" :canCancel="cancel" :onCancel="closeModal">
    <div class="card">
      <header class="card-header">
        <p class="card-header-title">{{ model }}でのスコアリング結果</p>
      </header>
      <div class="card-content">
        <b-table :data="scores" :columns="columns"></b-table>
      </div>
      <footer class="card-footer">
        <a class="card-footer-item" @click="closeModal">閉じる</a>
      </footer>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ScoreModal',
  props: {
    isModalActive: {type: Boolean, default: false},
    raw: {},
    model: {type: String, default: ''},
    scores: Array,
    columns: Array,
    cancel: {type: Boolean, default: false}
  },
  methods: {
    closeModal () {
      this.$parent.result.isModalActive = false
    }
  }
}
</script>

<style scoped>
  .card {
    width: 960px;
  }
  .card-content {
    overflow-x: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/ScoreModal.vue